import * as styles from './styles';
import FocusableInput from '@components/FocusableInput';
import { usePatientNameContext } from '@context/PatientName';
import { NAME_INPUT } from '../../../focuskey';

const InputContainer = () => {
  const { setInputName, name, focusCompleteButton, isEmptyValue } =
    usePatientNameContext();

  return (
    <div>
      <FocusableInput
        focusKey={NAME_INPUT}
        value={name}
        maxLength={30}
        onEnterPress={focusCompleteButton}
        onChange={setInputName}
        placeholder="이름을 입력하세요."
      />
      {isEmptyValue && <p css={styles.guideText}>이름을 반드시 입력해주세요.</p>}
    </div>
  );
};

export default InputContainer;
